import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getSuppliers
} from "../../api/supplierApi";

import {
  getMaterials
} from "../../api/materialApi";

import {
  createGRN
} from "../../api/grnApi";

const GRN = () => {

  const [suppliers,setSuppliers] =
  useState([]);

  const [materials,setMaterials] =
  useState([]);

  const [form,setForm] =
  useState({

    supplier_id:"",
    invoice_no:"",
    invoice_date:"",
    remarks:""

  });

  const [items,setItems] =
  useState([

    {
      material_id:"",
      quantity:"",
      rate:""
    }

  ]);

  useEffect(()=>{

    loadData();

  },[]);

  const loadData =
  async()=>{

    try{

      const supplierRes =
      await getSuppliers();

      const materialRes =
      await getMaterials();

      setSuppliers(
        supplierRes.data.data || []
      );

      setMaterials(
        materialRes.data.data || []
      );

    }
    catch(error){

      console.log(error);

    }

  };

  const addRow =
  ()=>{

    setItems([
      ...items,
      {
        material_id:"",
        quantity:"",
        rate:""
      }
    ]);

  };

  const updateItem =
  (index,key,value)=>{

    const updated =
    [...items];

    updated[index][key] =
    value;

    setItems(updated);

  };

  const saveGRN =
async(e)=>{

  e.preventDefault();

  try{

    await createGRN({

      ...form,

      items

    });

    alert(
      "GRN Saved Successfully"
    );

    setForm({

      supplier_id:"",
      invoice_no:"",
      invoice_date:"",
      remarks:""

    });

    setItems([

      {
        material_id:"",
        quantity:"",
        rate:""
      }

    ]);

  }
  catch(error){

    console.log(error);

    alert(
      "Failed To Save GRN"
    );

  }

};

  return(

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header">

          <h5>
            Goods Receipt Note
          </h5>

        </div>

        <div className="card-body">

          <form
            onSubmit={saveGRN}
          >

            <div className="row">

              <div className="col-md-4">

                <label>
                  Supplier
                </label>

                <select
                  className="form-select"
                  value={
                    form.supplier_id
                  }
                  onChange={(e)=>
                    setForm({
                      ...form,
                      supplier_id:
                      e.target.value
                    })
                  }
                >

                  <option value="">
                    Select Supplier
                  </option>

                  {
                    suppliers.map(
                      supplier=>(
                        <option
                          key={supplier.id}
                          value={supplier.id}
                        >
                          {supplier.supplier_name}
                        </option>
                      )
                    )
                  }

                </select>

              </div>

              <div className="col-md-4">

                <label>
                  Invoice No
                </label>

                <input
                  className="form-control"
                  value={
                    form.invoice_no
                  }
                  onChange={(e)=>
                    setForm({
                      ...form,
                      invoice_no:
                      e.target.value
                    })
                  }
                />

              </div>

              <div className="col-md-4">

                <label>
                  Invoice Date
                </label>

                <input
                  type="date"
                  className="form-control"
                  value={
                    form.invoice_date
                  }
                  onChange={(e)=>
                    setForm({
                      ...form,
                      invoice_date:
                      e.target.value
                    })
                  }
                />

              </div>

            </div>

            <hr />

            <table className="table">

              <thead>

                <tr>

                  <th>
                    Material
                  </th>

                  <th>
                    Qty
                  </th>

                  <th>
                    Rate
                  </th>

                  <th>
                    Amount
                  </th>

                </tr>

              </thead>

              <tbody>

                {
                  items.map(
                    (item,index)=>{

                      const amount =
                      Number(
                        item.quantity || 0
                      ) *
                      Number(
                        item.rate || 0
                      );

                      return(

                        <tr
                          key={index}
                        >

                          <td>

                            <select
                              className="form-select"
                              value={
                                item.material_id
                              }
                              onChange={(e)=>
                                updateItem(
                                  index,
                                  "material_id",
                                  e.target.value
                                )
                              }
                            >

                              <option value="">
                                Select
                              </option>

                              {
                                materials.map(
                                  material=>(
                                    <option
                                      key={material.id}
                                      value={material.id}
                                    >
                                      {material.material_name}
                                    </option>
                                  )
                                )
                              }

                            </select>

                          </td>

                          <td>

                            <input
                              className="form-control"
                              value={
                                item.quantity
                              }
                              onChange={(e)=>
                                updateItem(
                                  index,
                                  "quantity",
                                  e.target.value
                                )
                              }
                            />

                          </td>

                          <td>

                            <input
                              className="form-control"
                              value={
                                item.rate
                              }
                              onChange={(e)=>
                                updateItem(
                                  index,
                                  "rate",
                                  e.target.value
                                )
                              }
                            />

                          </td>

                          <td>

                            {amount}

                          </td>

                        </tr>

                      );

                    }
                  )
                }

              </tbody>

            </table>

            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={addRow}
            >

              Add Material

            </button>

            <button
              type="submit"
              className="btn btn-primary"
            >

              Save GRN

            </button>

          </form>

        </div>

      </div>

    </MainLayout>

  );

};

export default GRN;